export const alertsEs = {
  alerts: {
    title: "Alertas y Notificaciones",
    subtitle: "Mantente informado sobre las condiciones de tu granja",
    activeAlerts: "Alertas Activas",
    alertHistory: "Historial de Alertas",
    settings: "Configuración de Alertas",
    priority: "Prioridad",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    type: "Tipo",
    weather: "Clima",
    pest: "Plaga",
    disease: "Enfermedad",
    irrigation: "Riego",
    frost: "Helada",
    markAsRead: "Marcar como Leída",
    dismiss: "Descartar",
    viewDetails: "Ver Detalles",
    noAlerts: "Sin alertas activas",
    allClear: "Todos los sistemas operando normalmente",
    filters: "Filtros",
    searchAlerts: "Buscar alertas...",
    allSeverities: "Todas las Severidades",
    critical: "Crítica",
    allStatus: "Todos los Estados",
    resolved: "Resuelta",
    allTypes: "Todos los Tipos",
    waterStress: "Estrés Hídrico",
    heatStress: "Estrés Térmico",
    cropStress: "Estrés del Cultivo",
    frostRisk: "Riesgo de Helada",
    stormWarning: "Alerta de Tormenta",
    floodingRisk: "Riesgo de Inundación",
    insuranceAlert: "Alerta de Seguro",
    generalRisk: "Riesgo General",
    totalAlerts: "Total de Alertas",
    activeAlertsCount: "Alertas Activas",
    criticalAlerts: "Alertas Críticas",
    resolvedCount: "Resueltas",
    allAlerts: "Todas las Alertas",
    showingAlerts: "Mostrando {{filtered}} de {{total}} alertas",
    noAlertsFound: "No Se Encontraron Alertas",
    noAlertsGenerated: "No se han generado alertas aún. Añade parcelas y genera análisis para recibir alertas.",
    noAlertsMatch: "Ninguna alerta coincide con tus filtros actuales. Intenta ajustar los criterios de búsqueda.",
    resolve: "Resolver",
    viewParcel: "Ver Parcela",
    alertResolved: "Alerta Resuelta",
    alertResolvedDesc: "La alerta ha sido marcada como resuelta.",
    alertResolveFailed: "Error al resolver la alerta. Inténtalo de nuevo.",
    loadingAlerts: "Cargando alertas...",
    parcel: "Parcela",
    alertType: "Tipo",
    alertDetails: "Detalles de Alerta"
  }
};
